import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Waypoint from 'react-waypoint';
import FixedWrapper from './FixedWrapper';
import ismobilejs from 'ismobilejs';

import './Story.css';

const POINTS = [`80%`];

class Story extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  _positions = POINTS.map(_ => null);

  state = {
    title: false,
    image: false,
    mobileChange: false,
    positions: this._positions
  };

  render() {
    const positionsClasses = this.state.positions.reduce((result, pos, idx) => ({
      ...result,
      [`step${idx}`]: pos
    }), {});

    return (
      <div
        className={classnames('Story', this.props.className, positionsClasses)}
        id="Story">
        <div className="Story__content">
          <Waypoint
            onPositionChange={this._onPositionChange.bind(this, 'title',)}
            bottomOffset="-200px"
          />
          <h2 className={classnames('Story__title', {
            'Story__title--appear': this.state.title
          })}>
            <FormattedMessage id="Story.title"/>
          </h2>
          {
             ismobilejs.any &&
             <Waypoint
               onPositionChange={this._onPositionChange.bind(this, 'image')}
               bottomOffset="200px"
             />
          }
          {
            ismobilejs.any ? (
              <div className={classnames('Story__mobileImageWrapper', {
                'Story__mobileImageWrapper--appear': this.state.image,
                'Story__mobileImageWrapper--mobileChange': this.state.mobileChange,
              })}>
                <div className="Story__mobileImage"/>
                <div className="Story__mobileImage2"/>
              </div>
            ) : (
              <FixedWrapper
                className="Story__imageFixedWrapper"
                height={250}
                points={POINTS}
                onPointPosition={this._updateAnim}>
                <div className="Story__imageWrapper">
                  <div className="Story__image"/>
                  <div className="Story__image2"/>
                </div>
              </FixedWrapper>
            )
          }
          {
             ismobilejs.any &&
             <Waypoint
               onPositionChange={this._onPositionChange.bind(this, 'mobileChange')}
             />
          }
        </div>
      </div>
    );
  }

  _onPositionChange = (key, { currentPosition }) => {
    if (currentPosition === 'above' || currentPosition === 'inside') {
      this.setState({
        [key]: true
      });
    } else if (currentPosition === 'below') {
      this.setState({
        [key]: false
      });
    }
  };

  _updateAnim = (idx, pos) => {
    this._positions[idx] = pos === 'above' || pos === 'inside';
    this.setState({
      positions: this._positions
    });
  };

}

export default Story;



// WEBPACK FOOTER //
// ./src/components/Story.js